/**
 * FAQ Module Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */
import type { RouteRecordRaw } from 'vue-router'
import type { Role } from '../../src/types'

const roles: Role[] = ['ai_lab_admin', 'mandant_admin']

const routes: RouteRecordRaw[] = [
  {
    path: '/faqs_categories',
    name: 'faq.overview',
    component: () => import('../../src/pages/faq/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/settings',
    name: 'faq.settings',
    component: () => import('./pages/FaqSettings.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/faqs',
    name: 'faq.faqs',
    component: () => import('../../src/pages/faq/faqs/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/faqs/:faqID',
    name: 'faq.faqDetail',
    component: () => import('../../src/pages/faq/faqs/DetailView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/categories',
    name: 'faq.categories',
    component: () => import('../../src/pages/faq/categories/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/categories/:categoryID',
    name: 'faq.categoryDetail',
    component: () => import('../../src/pages/faq/categories/DetailView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/translations',
    name: 'faq.translations',
    component: () => import('../../src/pages/faq/translations/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/translations/:translation/faqs',
    name: 'faq.translationFaqs',
    component: () => import('../../src/pages/faq/translations/FaqTranslations/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/translations/:translation/faqs/:faqID',
    name: 'faq.translationFaqDetail',
    component: () => import('../../src/pages/faq/translations/FaqTranslations/DetailView.vue'),
    meta: { requiresAuth: true, roles }
  },
  {
    path: '/faqs_categories/translations/:translation/categories',
    name: 'faq.translationCategories',
    component: () =>
      import('../../src/pages/faq/translations/CategoriesTranslation/OverallView.vue'),
    meta: { requiresAuth: true, roles }
  }
]

export default routes
